import { InteractionStatus } from "@azure/msal-browser";
import Button from "@mui/material/Button";
import type { ChipProps } from "@mui/material/Chip";
import Chip from "@mui/material/Chip";
import SvgIcon from "@mui/material/SvgIcon";
import MicrosoftIcon from "~assets/svg/icons/microsoft-logo-colored.svg?react";
import logoSrc from "~assets/svg/logo.svg";
import { useAuth } from "~auth/useAuth";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { classList } from "~lib/classList.ts";
import { useMarkFirstPaint } from "~lib/firstPaint.ts";

import styles from "./LoginPage.module.scss";

export function LoginPage() {
  const t = useTranslation();
  useMarkFirstPaint();

  return (
    <>
      <div className={styles.layout}>
        <div className={styles.container}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}>
              <img src={logoSrc} alt="Grewe Logo" />
              <BetaChip />
            </div>
          </div>
          <div className={styles.welcomeContainer}>
            <div className={styles.welcomeContainer__content}>
              <h1 className={styles.welcomeContainer__title}>
                {t.loginPageTitle}{" "}
                <span>
                  App
                  <BetaChip />
                </span>
              </h1>
              {/* biome-ignore lint/security/noDangerouslySetInnerHtml: trusted i18n translation string, no user input */}
              <div dangerouslySetInnerHTML={{ __html: t.loginPageTextHtml }} />
            </div>
            <div className={styles.welcomeContainer__actions}>
              <SignInButton />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.animationContainer}>
        <img src="/rasenmaeher.svg" alt="" />
      </div>
    </>
  );
}

function BetaChip({ ...props }: ChipProps) {
  return (
    <Chip
      className={classList(styles.betaChip, props.className)}
      label="beta"
      {...props}
    />
  );
}

function SignInButton() {
  const { login, inProgress } = useAuth();
  const t = useTranslation();

  return (
    <Button
      loading={inProgress !== InteractionStatus.None}
      startIcon={<SvgIcon component={MicrosoftIcon} inheritViewBox />}
      variant="outlined"
      size="large"
      onClick={async () => {
        await login();
      }}
    >
      {t.signIn}
    </Button>
  );
}
